import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';
import { AuthenticationService } from '../services/authService/authentication.service';
import { isJwtValid } from 'src/app/core/utils/jwt.util';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authservice: AuthenticationService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(state.url);

    if (isUserOfTypeCMS) {
      const currentUser = this.authservice.CurrentUserValue;
      if (currentUser?.AuthToken && isJwtValid(currentUser.AuthToken)) {
        //authorized
        return true;
      }
    } else {
      const currentRespondUser = this.authservice.RespondUserValue;
      if (currentRespondUser?.AuthToken && isJwtValid(currentRespondUser.AuthToken)) {
        //authorized
        return true;
      }
    }
    //else return to login page
    this.router.navigate(['/auth/login']);
    return false;
  }

}
